import { useState } from "react";
import { MdClose } from "react-icons/md";
import { useApplication } from "../../../contexts/ApplicationContext";
import { INTERACTION_LABELS, INTERACTION_OUTCOMES } from "../crmHelpers";

/*
  "Como foi o contato?"

  Sai do próprio histórico, e não de um estado da tela: a pessoa manda a mensagem na
  outra aba e volta quando der, às vezes depois de recarregar a página. Enquanto o
  contato recente dela estiver sem resultado, a pergunta continua aqui.

  Fica por cima da tela, em vez de dentro da coluna de contato: no celular essa coluna
  fica lá embaixo, e a pergunta passaria despercebida.
*/

const ASK_WINDOW_MS = 2 * 60 * 60 * 1000;
const ASKABLE_TYPES = ["WHATSAPP", "CALL", "EMAIL", "MEETING"];

export const pendingOutcomeOf = (timeline = [], userId) =>
  timeline.find(
    (item) =>
      item.kind === "INTERACTION" &&
      ASKABLE_TYPES.includes(item.type) &&
      !item.outcome &&
      Number(item.authorId) === Number(userId) &&
      Date.now() - new Date(item.at).getTime() < ASK_WINDOW_MS
  ) || null;

const OutcomePrompt = ({ timeline, onAnswer, isSaving }) => {
  const { user } = useApplication();
  const [dismissed, setDismissed] = useState([]);

  const pending = pendingOutcomeOf(timeline, user?.id);
  if (!pending || dismissed.includes(pending.id)) return null;

  return (
    <div
      role="status"
      data-testid="outcome-prompt"
      className="fixed bottom-4 right-4 z-[60] w-[calc(100vw-2rem)] max-w-sm rounded-2xl border border-slate-200 bg-white p-3.5 shadow-2xl"
    >
      <div className="flex items-start justify-between gap-2">
        <p className="text-sm font-semibold text-slate-900">
          Como foi o contato por {INTERACTION_LABELS[pending.type] || pending.type}?
        </p>
        <button
          type="button"
          onClick={() => setDismissed((previous) => [...previous, pending.id])}
          title="Responder depois"
          className="shrink-0 rounded-md p-0.5 text-slate-400 transition hover:bg-slate-100 hover:text-slate-700"
        >
          <MdClose size={16} />
        </button>
      </div>

      <div className="mt-2 flex flex-wrap gap-1.5">
        {INTERACTION_OUTCOMES.map((option) => (
          <button
            key={option.value}
            type="button"
            disabled={isSaving}
            onClick={() =>
              onAnswer({ interactionId: pending.id, outcome: option.value })
            }
            className="rounded-full border border-slate-200 px-3 py-1 text-xs font-semibold text-slate-700 transition hover:border-pink-300 hover:text-pink-700 disabled:opacity-40"
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default OutcomePrompt;
